/* eslint-disable no-underscore-dangle */
// underscore-dangle é uma convenção adotada pelo leafelt para atributos privados

import { GeoJSON } from 'leaflet';

// Adicionando método setZIndex para possibilitar sobreposição de camadas geoJson na mesma pane
GeoJSON.include({
  setZIndex: function (zIndex) {
    if (this.options.renderer && this.options.renderer.setZIndex)
      this.options.renderer.setZIndex(zIndex);
  },
});
